module.exports = __webpack_public_path__ + "img/issue-not-listed.a22dd5a.png";